import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useQueryProvider } from '@/modules/QueryProvider';
import ConstituentSearchDefaultValues from '../constants/ConstituentSearchDefaultValues';
import type ConstituentFilterFormData from '../types/ConstituentFilterFormData';
import type ConstituentSearchFilterParams from '../types/ConstituentSearchFilterParams';
import mapFormDataToFilters from '../utils/mapFormDataToFilters';

const useConstituentSearchFilter = () => {
  const { updateQuery } = useQueryProvider<ConstituentSearchFilterParams>();
  const { getValues } = useFormContext<ConstituentFilterFormData>();

  const updateFilters = React.useCallback(() => {
    const formData = getValues();
    const filters = mapFormDataToFilters(
      ConstituentSearchDefaultValues,
      formData,
    );
    updateQuery({ filterName: null, filters: filters.length ? filters : null });
  }, [getValues, updateQuery]);

  return { updateFilters };
};

export default useConstituentSearchFilter;
